export default __webpack_public_path__ + "static/media/menu.d42d147a.svg";